// Cart functionality
function toggleCart() {
    const cartSidebar = document.querySelector('.cart-sidebar');
    const cartOverlay = document.querySelector('.cart-overlay');

    // Refresh cart before opening to ensure it's up-to-date
    if (!cartSidebar.classList.contains('open')) {
        refreshCart();
    }

    cartSidebar.classList.toggle('open');
    cartOverlay.classList.toggle('active');
}

// Add to cart from product cards
function addToCart(event, variantId, productName, price) {
    event.preventDefault();
    event.stopPropagation();
    
    console.log('Adding to cart:', { variantId, productName, price });
    
    const formData = {
        'items': [{
            'id': variantId,
            'quantity': 1
        }]
    };
    
    // Visual feedback immediately
    const btn = event.target;
    const originalText = btn.textContent;
    btn.textContent = '⏳ Toevoegen...';
    btn.disabled = true;
    
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        console.log('Cart response status:', response.status);
        return response.json();
    })
    .then(data => {
        console.log('Cart data:', data);

        // Visual feedback
        btn.textContent = '✓ Toegevoegd!';
        btn.style.background = '#10b981';

        // Update cart count
        updateCartCount();

        // Refresh cart and then show sidebar
        refreshCart().then(() => {
            // Open cart sidebar without refreshing again
            const cartSidebar = document.querySelector('.cart-sidebar');
            const cartOverlay = document.querySelector('.cart-overlay');
            if (!cartSidebar.classList.contains('open')) {
                cartSidebar.classList.add('open');
                cartOverlay.classList.add('active');
            }
        });

        setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
        }, 2000);
    })
    .catch(error => {
        console.error('Cart error:', error);
        btn.textContent = '❌ Fout';
        btn.style.background = '#ef4444';
        
        setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.disabled = false;
        }, 2000);
        
        alert('Er ging iets mis. Probeer het opnieuw.');
    });
}

// Update cart quantity in sidebar
function updateCartQuantity(line, quantity) {
    if (quantity < 1) {
        removeFromCart(line);
        return;
    }
    
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'line': line,
            'quantity': quantity
        })
    })
    .then(response => response.json())
    .then(data => {
        refreshCart();
        updateCartCount();
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

// Remove item from cart
function removeFromCart(line) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'line': line,
            'quantity': 0
        })
    })
    .then(response => response.json())
    .then(data => {
        refreshCart();
        updateCartCount();
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

// Refresh cart sidebar
function refreshCart() {
    return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        const cartItemsEl = document.getElementById('cartItems');
        const cartTotalEl = document.getElementById('cartTotal');

        if (cart.item_count === 0) {
            cartItemsEl.innerHTML = '<p style="color: #666; text-align: center; padding: 2rem 0;">Je winkelwagen is leeg</p>';
            cartTotalEl.textContent = formatMoney(0);
            return;
        }

        let html = '';
        cart.items.forEach((item, index) => {
            const line = index + 1;
            html += `
                <div class="cart-item" data-line="${line}">
                    <div class="cart-item-image">
                        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : '<div class="placeholder">📦</div>'}
                    </div>
                    <div class="cart-item-info">
                        <div class="cart-item-title">${item.product_title}</div>
                        <div class="cart-item-price">${formatMoney(item.price)} × ${item.quantity} = ${formatMoney(item.line_price)}</div>
                        <div class="quantity-controls">
                            <button class="quantity-btn" onclick="updateCartQuantity(${line}, ${item.quantity - 1})">−</button>
                            <span class="quantity-display">${item.quantity}</span>
                            <button class="quantity-btn" onclick="updateCartQuantity(${line}, ${item.quantity + 1})">+</button>
                            <button class="remove-item" onclick="removeFromCart(${line})">Verwijderen</button>
                        </div>
                    </div>
                </div>
            `;
        });

        cartItemsEl.innerHTML = html;
        cartTotalEl.textContent = formatMoney(cart.total_price);
    })
    .catch(error => {
        console.error('Error refreshing cart:', error);
    });
}

// Update cart count
function updateCartCount() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        const cartCountEl = document.getElementById('cart-count');
        if (cartCountEl) {
            cartCountEl.textContent = cart.item_count;
        }
    })
    .catch(error => {
        console.error('Error updating cart count:', error);
    });
}

// Cart page functions
function updateCartItemQuantity(line, quantity) {
    if (quantity < 1) {
        removeCartItem(line);
        return;
    }
    
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'line': line,
            'quantity': quantity
        })
    })
    .then(response => response.json())
    .then(data => {
        // Reload page to update cart
        location.reload();
    })
    .catch(error => {
        console.error('Error:', error);
        alert('Er ging iets mis. Probeer het opnieuw.');
    });
}

function removeCartItem(line) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'line': line,
            'quantity': 0
        })
    })
    .then(response => response.json())
    .then(data => {
        // Reload page to update cart
        location.reload();
    })
    .catch(error => {
        console.error('Error:', error);
        alert('Er ging iets mis. Probeer het opnieuw.');
    });
}

// Format money helper
function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

// Mobile menu toggle
function toggleMobileMenu() {
    const navLinks = document.querySelector('.nav-links');
    const menuBtn = document.querySelector('.mobile-menu-btn');
    navLinks.classList.toggle('open');
    menuBtn.classList.toggle('active');
}

// Initialize
document.addEventListener('DOMContentLoaded', function() {
    // Update cart count on page load
    updateCartCount();

    // Mobile menu button
    const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
    if (mobileMenuBtn) {
        mobileMenuBtn.addEventListener('click', toggleMobileMenu);
    }
});
